import React from 'react';

const PartnerCard = ({ partner }) => {
  return (
    <>
    <div>
      <a className='cards-hyperlink' href={partner.websiteUrl} target='_blank'>
        <div className='cards-container'>
          <img className="logo" src={partner.logoUrl}/>
          <div className='cards-name-and-content-container'>
            <p className='cards-name t1 w3 mb-10'>{partner.name}</p>
            <div className='cards-content-container'>
              <div>{partner.description}</div>
            </div>
            <div className='mt-10'>{partner.categoryNames}</div>
          </div>
        </div>
      </a>
    </div>
  </>
  );
};

export default PartnerCard;
